import * as templateFunctions from "../templateFunctions/index.js";
import { resolveComplexTemplate } from "../../../utils/template/resolveComplexTemplate.js";
import { enhanceHTML } from "../../../utils/template/enhanceHTML.js";

const popupTemplate = `
| {setTitle(properties.time_series)} | |
|--|--|
| Start Date | {properties.start_date} |
| Information | [{properties.information}]({properties.information}) |
| Institute | {properties.institute} |
| Principal Investigator | {properties.principal_investigator} |
| Ocean Region | {properties.ocean_region} |
| Contact | [{properties.contact}]({properties.contact}) |
`
const sidebarTemplate = `
| {setTitle(properties.time_series)} | |
|--|--|
| Start Date | {properties.start_date} |
| Information | [{properties.information}]({properties.information}) |
| Institute | {properties.institute} |
| Principal Investigator | {properties.principal_investigator} |
| Ocean Region | {properties.ocean_region} |
| Contact | [{properties.contact}]({properties.contact}) |

{lto(properties.lat, properties.lng)}
`;

/**
 * Exported function to register the template
 * 
 * @param {PopupRenderer} renderer static PopupRenderer class
 * 
 * @memberof vef.map.popup.templates
 */
export function lto(renderer) {
    const template = (content, response, layer, style) => {
        let fields = content?.FeatureInfoResponse?.FIELDS;
        if (!fields) {
            if (content?.type == "field") {
                fields = content;
            } else {
                return [];
            }
        }
        if (!Array.isArray(fields)) fields = [fields];

        const responses = [];

        for (let i = 0; i < fields.length; ++i) {
            const data = {
                layer: layer,
                response: response,
                properties: fields[i]["@attributes"]
            };
            fields[i].type = "field";
            try {
                console.log(fields[i]["@attributes"])
                const html = resolveComplexTemplate((style == "sidebar") ? sidebarTemplate : popupTemplate, data, templateFunctions, {
                    markdown: true,
                    postProcess: true
                });
                enhanceHTML(html, (style == "sidebar") ? {} : { groupedHeadlines: false })
                responses.push({
                    response: response,
                    feature: fields[i],
                    layer: layer,
                    title: html.dataset.title || layer.title,
                    html: html
                });
            } catch (msg) {
                if (msg != "discard_template") console.warn(msg);
            }
        }

        return responses;
    };

    renderer.registerTemplate('lto', template);
}